import script from "./wordShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./wordShow.vue?vue&type=script&setup=true&lang=ts"

import "./wordShow.vue?vue&type=style&index=0&id=dc0af53a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0af53a"]])

export default __exports__